export default "__VITE_ASSET__Byupt1cH__"